import { formatFinancialCurrency, formatSobValue } from 'partner360/lib/metricFormatting'

const formatPercentValue = (value: number | null | undefined): string | null =>
  formatSobValue(value)

export const formatPercentChange = (value: number | null | undefined): string => {
  const formattedValue = formatPercentValue(value)

  if (formattedValue === null || value === null || value === undefined) {
    return '—'
  }

  return value >= 0 ? `+${formattedValue}%` : `${formattedValue}%`
}

export const formatCurrency = (value: number): string => formatFinancialCurrency(value)
